import React from "react";
import toast from "react-hot-toast";
import withProviders from "../../hooks/withProviders";
import { Main } from "../../components/utilities";
import { IconButton } from "../../components";
import { GraphSubscriptionsPageSubHeader } from "../../components/utilities/PageSubHeader";
import { FormInputWithSearchIcon } from "../../components/forms";
import GraphSubscriptionsTable, {
    GraphSubscriptionListProvider,
    openCreateSubscriptionModal,
    useGraphSubscriptions
} from "../../features/graphsubscriptionstable";
import { useCreateSubscriptionMutation } from "../../services/graph";

const GraphSubscriptionsPage = () => {
    const { clear, searchTerm, setSearchTerm } = useGraphSubscriptions();
    const [create, { isLoading }] = useCreateSubscriptionMutation();

    const handleOnCreate = () => {
        openCreateSubscriptionModal().then(
            data => {
                create(data)
                .unwrap()
                .then(
                    () => clear(),
                    () => toast.error('Failed to create subscription.')

                );
            },
            () => {}
        );
    };

    return (
        <React.Fragment>
            <Main className="d-flex flex-column">
                <GraphSubscriptionsPageSubHeader>
                    <div className="d-flex justify-content-between align-items-center">

                    </div>
                    <div className="d-flex flex-fill justify-content-end align-items-center gap-2">
                        <FormInputWithSearchIcon
                            className="w-25"
                            placeholder="Search subscriptions..."
                            value={searchTerm}
                            disabled={isLoading}
                            onChange={(e: any) => setSearchTerm(e.target.value)}
                        />
                        <IconButton icon={['fas', 'plus']} onClick={handleOnCreate} disabled={isLoading} variant='success'>
                            New Subscription
                        </IconButton>
                    </div>
                </GraphSubscriptionsPageSubHeader>
                <section className="px-4 my-3 h-100">
                    <GraphSubscriptionsTable />
                </section>
            </Main>
        </React.Fragment>
    )
};

export default withProviders(GraphSubscriptionListProvider)(GraphSubscriptionsPage);